import * as t from 'io-ts';

export const filterRecordCodec = t.intersection([
  t.type({
    id: t.union([t.string, t.number]),
    title: t.string,
  }),
  t.partial({
    is_deleted: t.union([t.boolean, t.undefined]),
  }),
]);

export const filterCodec = t.type({
  data: t.array(filterRecordCodec),
});
